import classNames from 'classnames';
import styles from './supreme-header.module.css';
import { ReactComponent as ExpandNav } from '../../assets/icons/close-nav.svg';

interface ExpandNavButtonProps {
    isMobile: boolean;
    isNavHidden: boolean;
    isNavOpen: boolean;
    onOpenNav: () => void;
}

export function ExpandNavButton({ isMobile, isNavHidden, isNavOpen, onOpenNav }: ExpandNavButtonProps) {
    if (isMobile || isNavHidden) return null;
    return (
        <button
            type="button"
            className={classNames(styles['supreme-header__expand-icon-container'], { [styles['supreme-header__expand-icon-container--closed']]: isNavOpen })}
            onClick={onOpenNav}
        >
            <ExpandNav className={classNames(styles['supreme-header__expand-icon'], { [styles['supreme-header__expand-icon--closed']]: isNavOpen })}
            />
        </button>
    );
}
